import { useEffect, useLayoutEffect, useState } from 'react'
import { getRouteApi } from '@tanstack/react-router'
import { useAppStore } from '@/lib/app-store'

const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect

const rootApi = getRouteApi('__root__')

// null while the theme is unknown: in system mode the server has no cookie, and guessing paints the light
// variant and flashes to dark after hydration. Seeded from the root loader's cookie-resolved theme.
export function useResolvedTheme(): 'light' | 'dark' | null {
  const { theme } = rootApi.useLoaderData()
  const storeResolved = useAppStore((state) => state.store.resolvedDarkMode)
  const [resolved, setResolved] = useState<'light' | 'dark' | null>(
    theme === 'dark' ? 'dark' : theme === 'light' ? 'light' : null,
  )

  useIsomorphicLayoutEffect(() => {
    setResolved(document.documentElement.classList.contains('dark') ? 'dark' : 'light')
  }, [storeResolved])

  return resolved
}
